import { render, staticRenderFns } from "./postingakhirtahun.vue?vue&type=template&id=334079e6&scoped=true&"
import script from "./postingakhirtahun.vue?vue&type=script&lang=js&"
export * from "./postingakhirtahun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334079e6",
  null
  
)

export default component.exports